import { changePasswordRequest, forgotPasswordRequest, loginUserRequest, logoutRequest, resetPasswordRequest, signupRequest } from "queries/auth-queries";
import { ApiResponse } from "helpers/fetch-wrapper";
import { useUserData } from "store/user-data";

// please check src/store/user-data.ts
interface User {
    username: string;
    email?: string;
    phone_number: string;
    is_business_owner: boolean;
    access_token: string; // updated
    refresh_token: string;
    business_id?: string;
    business_domain?: string;
    business_name?: string;
    business_logo?: string;
}

export async function signInAction(signInData: any) {
    const response = await loginUserRequest(signInData);
    const data: User = await response.json();

    const apiResponse: ApiResponse<User> = {
        body: data,
        message: data['message'],
        status: response.status,
        error: response.status === 200 ? null : data['message'],
    }

    useUserData.setState({ userData: data })

    return apiResponse
}

export async function signOutAction() {
    const response = await logoutRequest();
    const data = await response.json();

    const apiResponse: ApiResponse<any> = {
        body: data,
        message: data['message'],
        status: response.status,
        error: response.status === 200 ? null : data['message'],
    }

    useUserData.getState().deleteUserData();

    return apiResponse
}

export async function changePasswordAction(dat: any) {
    try {
        const response = await changePasswordRequest(dat);
        const data = await response.json();

        const apiResponse: ApiResponse<any> = {
            body: data,
            message: data['message'],
            status: response.status,
            error: response.status === 200 ? null : data['message'],
        }

        return apiResponse

    } catch (err) {
        const apiResponse: ApiResponse<any> = {
            body: null,
            message: 'Failed to change password, An error occurred',
            status: 500,
            error: err,
        }

        return apiResponse
    }

}

async function passwordResetResponse(request: Promise<Response>) {
    try {
        const response = await request;
        const data = await response.json();
        return {
            body: data,
            message: data.message,
            status: response.status,
            error: response.ok ? null : data.message,
        } as ApiResponse<any>;
    } catch (err) {
        return {
            body: null,
            message: "An unexpected error occurred. Please try again.",
            status: 500,
            error: String(err),
        } as ApiResponse<any>;
    }
}

export async function forgotPasswordAction(data: { email: string }) {
    return passwordResetResponse(forgotPasswordRequest(data));
}

export async function resetPasswordAction(data: {
    uid: string;
    token: string;
    newPassword: string;
}) {
    return passwordResetResponse(resetPasswordRequest(data));
}

export async function refreshTokenAction() { }

export async function signUpAction(signUpData: any) {
    const response = await signupRequest(signUpData);
    const data: User = await response.json();

    const apiResponse: ApiResponse<User> = {
        body: data,
        message: data['message'],
        status: response.status,
        error: response.status === 201 ? null : data['message'],
    }

    if (response.status === 201) {
        useUserData.setState({ userData: data })
    }

    return apiResponse
}
